import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

import { Icons } from '@/assets/icons/icons';
import { XStack } from '@/components/ui/layout/layout';
import { electronApis } from '@/features/electron-api';
import { tabStore } from '@/features/tabs/tabs.store';
import { cn } from '@/lib/utils';
import { isWindows } from '@/utils';

const BUTTON_CLASS =
  'flex items-center justify-center size-7 rounded-md transition-colors text-foreground-subtle hover:text-foreground hover:bg-secondary-hover';

export const WindowControls = observer(() => {
  if (!isWindows()) return null;

  const showTabBarStyle = tabStore.showTabBar;

  const [maximized, setMaximized] = useState(false);

  useEffect(() => {
    electronApis.window.isWindowMaximized().then(setMaximized);
  }, []);

  return (
    <XStack
      className={cn(
        'items-center gap-0.5 shrink-0 px-2',
        showTabBarStyle && 'bg-background h-full'
      )}
    >
      <button
        type="button"
        className={BUTTON_CLASS}
        onClick={() => electronApis.window.minimizeWindow()}
        aria-label="Minimize"
      >
        <Icons.minus className="size-3.5" />
      </button>
      <button
        type="button"
        className={BUTTON_CLASS}
        onClick={() => {
          electronApis.window.maximizeWindow();
          setMaximized((prev) => !prev);
        }}
        aria-label={maximized ? 'Restore' : 'Maximize'}
      >
        {maximized ? (
          <Icons.copy className="size-3" />
        ) : (
          <Icons.square className="size-3" />
        )}
      </button>
      <button
        type="button"
        className={cn(BUTTON_CLASS, 'hover:bg-red-600 hover:text-white')}
        onClick={() => electronApis.window.closeWindow()}
        aria-label="Close"
      >
        <Icons.cancel className="size-3.5" />
      </button>
    </XStack>
  );
});
